<div class="page-header">
  <app-page-title>
    <button page-title-action class="btn btn-primary btn-sm d-inline-flex align-items-center gap-2"
            (click)="save()" [disabled]="isSubmitting()">
      @if (isSubmitting()) {
        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none"
             stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"/>
          <polyline points="17 21 17 13 7 13 7 21"/>
          <polyline points="7 3 7 8 15 8"/>
        </svg>
      }
      <span>บันทึก</span>
    </button>
  </app-page-title>
</div>

@if (isLoading()) {
  <div class="text-center py-5 text-body-secondary">กำลังโหลดข้อมูล...</div>
} @else {
  <form [formGroup]="form">
    <div class="card shadow-sm border-0 mb-4">
      <div class="card-header py-3 bg-white">
        <div class="fw-semibold">Bot Channel</div>
      </div>
      <div class="card-body">
        <div class="alert alert-info d-flex align-items-start gap-2 mb-3" role="status">
          <i class="bi bi-info-circle mt-1"></i>
          <div>
            <div class="fw-semibold mb-1">คำแนะนำการตั้งค่า Webhook ใน LINE Developers Console:</div>
            <ol class="mb-0 ps-3">
              <li>กรอก <strong>Channel Secret</strong> และ <strong>Channel Access Token</strong> ด้านล่างนี้ แล้วกดปุ่ม <strong>"บันทึก"</strong> ให้เรียบร้อยก่อน</li>
              <li>จากนั้นนำ <strong>Webhook URL</strong> ไปใส่ใน LINE Developers Console (เมนู <em>Messaging API &gt; Webhook settings</em>) และเปิดใช้งาน <em>Use webhook</em></li>
            </ol>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="webhookUrl" class="form-label mb-0">Webhook URL</label></div>
          <div class="col-12 col-md-8">
            <input type="text" class="form-control form-control-sm font-monospace bg-light" id="webhookUrl"
                   [value]="webhookUrl" readonly (click)="$any($event.target).select()">
            <div class="form-text text-body-secondary">นำ URL นี้ไปกรอกในช่อง Webhook URL บน LINE Developers Console หลังจากบันทึกการตั้งค่าแล้ว</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="channelSecret" class="form-label required mb-0">Channel Secret</label></div>
          <div class="col-12 col-md-8">
            <input type="text" class="form-control form-control-sm" id="channelSecret"
                   formControlName="channelSecret"
                   [class.is-invalid]="submitted && form.get('channelSecret')?.invalid">
            @if (submitted && form.get('channelSecret')?.invalid) {
              <div class="invalid-feedback d-block">กรุณากรอก Channel Secret</div>
            }
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="channelAccessToken" class="form-label required mb-0">Channel Access Token</label></div>
          <div class="col-12 col-md-8">
            <textarea class="form-control form-control-sm" id="channelAccessToken" rows="3"
                      formControlName="channelAccessToken"
                      [class.is-invalid]="submitted && form.get('channelAccessToken')?.invalid"></textarea>
            @if (submitted && form.get('channelAccessToken')?.invalid) {
              <div class="invalid-feedback d-block">กรุณากรอก Channel Access Token</div>
            }
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4">
      <div class="card-header py-3 bg-white">
        <div class="fw-semibold">กลุ่มแจ้งเตือน</div>
      </div>
      <div class="card-body">
        <h6 class="text-secondary">ห้องทดลอง</h6>
        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="testGroupId" class="form-label required mb-0">Group ID</label></div>
          <div class="col-12 col-md-4">
            <input type="text" class="form-control form-control-sm" id="testGroupId"
                   formControlName="testGroupId"
                   [class.is-invalid]="submitted && form.get('testGroupId')?.invalid">
            @if (submitted && form.get('testGroupId')?.invalid) {
              <div class="invalid-feedback d-block">กรุณากรอก Group ID</div>
            }
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="testGroupName" class="form-label required mb-0">ชื่อกลุ่ม</label></div>
          <div class="col-12 col-md-4">
            <input type="text" class="form-control form-control-sm" id="testGroupName"
                   formControlName="testGroupName"
                   [class.is-invalid]="submitted && form.get('testGroupName')?.invalid">
            @if (submitted && form.get('testGroupName')?.invalid) {
              <div class="invalid-feedback d-block">กรุณากรอกชื่อกลุ่ม</div>
            }
          </div>
        </div>

        <hr>

        <h6 class="text-secondary">ห้องจริง</h6>
        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="prodGroupId" class="form-label required mb-0">Group ID</label></div>
          <div class="col-12 col-md-4">
            <input type="text" class="form-control form-control-sm" id="prodGroupId"
                   formControlName="prodGroupId"
                   [class.is-invalid]="submitted && form.get('prodGroupId')?.invalid">
            @if (submitted && form.get('prodGroupId')?.invalid) {
              <div class="invalid-feedback d-block">กรุณากรอก Group ID</div>
            }
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="prodGroupName" class="form-label required mb-0">ชื่อกลุ่ม</label></div>
          <div class="col-12 col-md-4">
            <input type="text" class="form-control form-control-sm" id="prodGroupName"
                   formControlName="prodGroupName"
                   [class.is-invalid]="submitted && form.get('prodGroupName')?.invalid">
            @if (submitted && form.get('prodGroupName')?.invalid) {
              <div class="invalid-feedback d-block">กรุณากรอกชื่อกลุ่ม</div>
            }
          </div>
        </div>

        <p class="text-body-secondary small mb-0 mt-1">ห้องจริงคือห้องที่ใช้งานจริง คำขอแต่ละรายการจะส่งเข้าห้องนี้ได้เพียงครั้งเดียว คำขอที่เคยส่งแล้วจะไม่ถูกดึงมาส่งซ้ำอีก ส่วนห้องทดลองยังพิมพ์ “ส่งคำขอ” เพื่อทดสอบได้ตามปกติ</p>
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4">
      <div class="card-header py-3 bg-white d-flex justify-content-between align-items-center">
        <div class="fw-semibold">ผู้มีสิทธิ์ส่งคำขอ</div>
        <button type="button" class="btn btn-outline-primary btn-sm" (click)="addAllowedUser()">เพิ่มผู้ใช้</button>
      </div>
      <div class="card-body">
        <p class="text-body-secondary small">เมื่อผู้ใช้ในรายการส่งข้อความขึ้นต้นด้วย “ส่งคำขอ” จากกลุ่มที่อนุญาต ระบบจะตอบกลับในกลุ่มนั้น</p>
        @if (allowedUsers.length === 0) {
          <div class="text-body-secondary">ยังไม่มีผู้ใช้ที่ได้รับอนุญาต</div>
        }
        <div formArrayName="allowedUsers">
          @for (allowedUser of allowedUsers.controls; track $index; let index = $index) {
            <div class="row g-2 mb-3" [formGroupName]="index">
              <div class="col-12 col-md-4">
                <label class="form-label required" [for]="'allowedUserName-' + index">ชื่อผู้ใช้</label>
                <input type="text" class="form-control form-control-sm" [id]="'allowedUserName-' + index"
                       formControlName="name"
                       [class.is-invalid]="submitted && allowedUser.get('name')?.invalid">
                @if (submitted && allowedUser.get('name')?.invalid) {
                  <div class="invalid-feedback">กรุณากรอกชื่อผู้ใช้</div>
                }
              </div>
              <div class="col-12 col-md-6">
                <label class="form-label required" [for]="'allowedUserId-' + index">LINE User ID</label>
                <input type="text" class="form-control form-control-sm" [id]="'allowedUserId-' + index"
                       formControlName="userId"
                       [class.is-invalid]="submitted && allowedUser.get('userId')?.invalid">
                @if (submitted && allowedUser.get('userId')?.hasError('required')) {
                  <div class="invalid-feedback">กรุณากรอก LINE User ID</div>
                } @else if (submitted && allowedUser.get('userId')?.hasError('pattern')) {
                  <div class="invalid-feedback">LINE User ID ต้องขึ้นต้นด้วย U และตามด้วยเลขฐานสิบหก 32 ตัว</div>
                }
              </div>
              <div class="col-12 col-md-2 d-flex align-items-end">
                <button type="button" class="btn btn-outline-danger btn-sm w-100" (click)="removeAllowedUser(index)">ลบ</button>
              </div>
            </div>
          }
        </div>
        @if (submitted && allowedUsers.hasError('duplicateUserId')) {
          <div class="text-danger small">LINE User ID ต้องไม่ซ้ำกัน</div>
        }
      </div>
    </div>

    <div class="card shadow-sm border-0 mb-4">
      <div class="card-header py-3 bg-white">
        <div class="fw-semibold">การส่งต่อ Webhook (Forward Webhook)</div>
      </div>
      <div class="card-body">
        <div class="alert alert-light border d-flex align-items-start gap-2 mb-3" role="status">
          <i class="bi bi-arrow-repeat text-primary mt-1"></i>
          <div>
            <div class="fw-semibold mb-2">เงื่อนไขการคัดแยกและการส่งต่อคำสั่ง (Routing Logic):</div>
            <div class="mb-2">
              <span class="badge bg-primary me-1">ระบบ tascode จัดการเอง</span>
              <span class="text-body-secondary small">คำสั่งที่ขึ้นต้นด้วยข้อความต่อไปนี้ ระบบนี้จะประมวลผลและตอบกลับโดยตรง:</span>
              <ul class="mb-1 ps-3 small text-body-secondary">
                <li><code>whoami</code> (รวมถึง <code>whoami group</code>, <code>whoami room</code>, <code>whoami user</code>) — คืนค่า ID สำหรับนำมาตั้งค่า</li>
                <li><code>ส่งคำขอ</code> — ตรวจสอบสิทธิ์และส่ง Flex Carousel คำขอที่รออนุมัติ</li>
                <li><code>แจ้งเตือนประจำวัน</code> — รายงานสถานะคำขอประจำวัน</li>
              </ul>
            </div>
            <div>
              <span class="badge bg-secondary me-1">ส่งต่อไปยังระบบปลายทาง</span>
              <span class="text-body-secondary small">ข้อความหรือคำสั่งอื่นทั้งหมดที่ไม่ตรงกับ 3 คำสั่งข้างต้น จะถูกส่งต่อ (Forward) ไปยัง URL ปลายทางที่กำหนด:</span>
              <ul class="mb-0 ps-3 small text-body-secondary">
                <li>คำสั่งเดิม เช่น <code>ลงทะเบียน</code>, <code>สืบค้น</code>, <code>cer</code> เป็นต้น</li>
                <li>รวมถึงคำสั่งและ Event อื่นๆ นอกเหนือจากที่ระบบนี้ดูแล</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12 col-md-2"><label for="forwardUrl" class="form-label mb-0">Forward Webhook URL</label></div>
          <div class="col-12 col-md-8">
            <input type="text" class="form-control form-control-sm font-monospace" id="forwardUrl"
                   formControlName="forwardUrl"
                   placeholder="https://example.com/api/webhook">
            <div class="form-text text-body-secondary">URL ปลายทางสำหรับรับส่งต่อ Webhook จากระบบนี้ (หากไม่ระบุ ระบบจะไม่ส่งต่อคำสั่งอื่นๆ)</div>
          </div>
        </div>
      </div>
    </div>
  </form>
}
